import React, { useEffect, useState } from 'react';
import { Drawer, alpha, Grid, Icon, makeStyles, Typography, useMediaQuery, useTheme, SvgIcon } from '@material-ui/core';
import { connect } from 'react-redux';
import { actionTypes } from '../../../store/actions'
import general_translations from '../../../texts/eng/general-translations'
import cx from 'classnames';
import SVGIcon from '../../../components/Structure/DisplayData/SVGIcon'
import { withRouter } from 'react-router';
import RoundedButton from '../../../components/Actions/RoundedButton';

const Sidebar = ({ open, history, ismobile, onItemSelected, onUpdateDrawerStatus, user }) => {

    const classes = useStyles()

    useEffect(() => {
        onUpdateDrawerStatus(!ismobile)
    }, [ismobile])

    const isURLSelected = (path) => {
        let historyPath = history.location.pathname.split('/')
        historyPath = historyPath.length < 2 ? null : `${historyPath[0]}/${historyPath[1]}`
        return historyPath === path;
    }
    const content = general_translations.sidebar

    const isAdmin = user && user.user_type_id ? user.user_type_id === 1 : false

    console.log(isAdmin)
    

    return (
        <div>
            <Drawer
                open={open}
                onClose={() => onUpdateDrawerStatus(false)}
                variant={ismobile ? 'temporary' : 'permanent'}
                //  classes={{ paper: classes.drawer }}
                classes={{
                    paper: cx({
                        [classes.drawerPaper]: true,
                        [classes.drawerPaperOpen]: open,
                        [classes.drawerPaperClose]: !open
                    })
                }}
            >
                <div className={classes.container}>
                    <div className={classes.logo_container}>
                        <img src={content.logo} alt='' className={classes.logo} />
                    </div>
                    <div className={classes.menu}>
                        <Grid container justifyContent='center' spacing={1}>
                            <Grid item xs={12}>
                                <Grid container justifyContent='center'>
                                    {content.list.map((item, key) => {

                                        const isactive = isURLSelected(item.path)

                                        if(item.adminOnly && !isAdmin)
                                            return null
                                        else
                                            return (
                                                <Grid item xs={12} key={key.toString()}>
                                                    <SidebarItem active={isactive} {...item} onChangeView={onItemSelected} arrow={content.arrow} isURLSelected={isURLSelected} />
                                                </Grid>
                                            )
                                    })}
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <SidebarItem secondary active={isURLSelected(content.logout.path)} {...content.logout} onChangeView={onItemSelected} />
                            </Grid>
                        </Grid>

                    </div>
                </div>

            </Drawer>
        </div >
    );
}

const useStyles = makeStyles(theme => ({
    drawerPaper: {
        color: theme.palette.secondary.main,
        background: 'white',
        overflow: 'hidden',
        position: 'relative',
        width: 120,
        height: '110vh',
        boxShadow: '0 10px 24px 0 rgba(82, 91, 115, .12)',
        border: 0,
        margin: 0,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerPaperOpen: {
        width: 120,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.enteringScreen,
        })
    },
    drawerPaperClose: {
        overflow: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: 0,
    },
    logo: {
        width: '100%',
        height: '100%',
        padding: 8,
        boxSizing: 'border-box',
        //objectFit:'cover',
        position: 'absolute',
        top: 0, left: 0
    },
    logo_container: {
        width: 52,
        height: 52,
        margin: 'auto',
        borderRadius: '50%',
        boxSizing: 'border-box',
        background: 'white',
        position: 'relative'
    },
    container: {
        width: 125,
        padding: '24px 0px',
        overflowY: 'auto',
        overflowX: 'hidden',
    },
    title: {
        marginTop: 8
    },
    menu: {
        marginTop: 24
    }
}))

const mapStateToProps = state => {
    return {
        open: state.drawer_status,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onUpdateDrawerStatus: (drawer_status) => dispatch({ type: actionTypes.SYS_UPDATE_DRAWER_STATUS, drawer_status })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar))


const SidebarItem = ({ active, name, path, icon, options, onChangeView, secondary, arrow, isURLSelected }) => {

    const classes = useStylesItem()
    const [open, setOpen] = useState(false)
    const [hover, setHover] = useState(false)
    const theme = useTheme()
    let innerActive = false

    return (
        <>
            <div
                className={cx({
                    [classes.root]: true,
                    [classes.secondary]: secondary,
                    [classes.active]: active || innerActive,
                    [classes.activeP]: active && secondary,
                })}
                onClick={options ? () => setOpen(prev => !prev) : () => onChangeView(path)}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >
                <div className={classes.module}>
                    {icon ?
                        <Grid container justifyContent='center' alignItems='center' spacing={1}>
                            <Grid item>
                                <SVGIcon
                                    src={icon}
                                    size={path === '/sponsors' ? 26 : 20}
                                    colorStroke={secondary ? theme.palette.secondary.main : null}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align='center' className={classes.title}>{name}</Typography>
                            </Grid>
                        </Grid>
                        :
                        <Typography align='center' className={classes.title}>{name}</Typography>}
                    {options &&
                        <div className={cx({ [classes.arrow]: true, [classes.arrow_open]: open })}>
                            <SVGIcon
                                src={arrow}
                                size={15}
                                colorStroke={secondary ? theme.palette.secondary.main : null}
                            />
                        </div>
                    }
                </div>
            </div>
            {open &&
                <div className={classes.submodule}>
                    {options.map((item, key) => {
                        innerActive = isURLSelected(item.path)

                        return (
                            <Grid item xs={12} key={key.toString()}>
                                <SidebarItem active={innerActive} {...item} onChangeView={onChangeView} />
                            </Grid>
                        )
                    })}
                </div>
            }
        </>
    )
}

const useStylesItem = makeStyles(theme => ({
    root: {
        color: theme.palette.secondary.main,
        padding: '10px 14px',
        '&:hover': {
            background: alpha(theme.palette.secondary.main, 0.1),
            cursor: 'pointer',
            transition: theme.transitions.create(['background'], {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        transition: theme.transitions.create(['background'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.leavingScreen,
        }),

    },
    secondary: {
        color: theme.palette.secondary.main,
        '&:hover': {
            background: alpha(theme.palette.secondary.main, 0.05)
        }
    },
    active: {
        background: 'rgba(189, 139, 64, 0.1)',
        color: theme.palette.secondary.main,
        // '&:hover': {
        //     color: 'white',
        //     background: theme.palette.secondary.main,
        //     cursor: 'pointer',
        // },
        transition: theme.transitions.create(['background'], {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    activeP: {
        background: 'rgba(109, 26, 18, 0.1)',
        '&:hover': {
            background: theme.palette.secondary.main,
        }
    },
    title: {
        fontSize: 12
    },
    module: {
        position: 'relative'
    },
    submodule: { marginTop: 10 },
    arrow: {
        height: '100%',
        top: 0,
        right: 5,
        position: 'absolute',
        transform: 'rotate(180deg) translateY(50%)'
    },
    arrow_open: {
        marginTop: -15,
        transform: 'rotate(0deg) translateY(50%)'
    }
}))